<template>
  <div class="main">
    <div class="content">
      <p>啊哦，网络飞到外太空了！</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: ""
    };
  },
  components: {
  },
  mounted() {
    
  },
  methods: {
  
  }
};
</script>
<style lang="less" scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .content{
    width: 300px;
    height: 260px;
    background: url(../../../assets/img/common/no_network.png) no-repeat center center;
    background-size:235px 228px;
    p{
      color:#005D77;
      font-size: 22px;
      padding-top:265px;
      padding-left: 20px;
    }
  }
 
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/message/noNetwork.vue